import { Tooltip } from '@pickleballinc/react-ui';
import clsx from 'clsx';

import { Button } from '@/components/atoms/Button';

interface ActionButtonsProps {
	closeButtonText: string;
	onClose: () => void;
	submitButtonText: string;
	className?: string;
	closeButtonClassName?: string;
	submitButtonClassName?: string;
	onSubmit?: () => void;
	submitButtonDisabled?: boolean;
	icon?: (disabled: boolean) => React.ReactNode;
	iconClassName?: string;
	isLoading?: boolean;
	submitTooltipMessage?: string;
}

export const ActionButtons = ({
	className,
	closeButtonText,
	closeButtonClassName,
	onClose,
	submitButtonText,
	submitButtonClassName,
	onSubmit,
	submitButtonDisabled = false,
	icon,
	iconClassName,
	isLoading = false,
	submitTooltipMessage
}: ActionButtonsProps) => {
	const submitButton = (
		<Button
			type="submit"
			onClick={onSubmit}
			disabled={submitButtonDisabled || isLoading}
			className={clsx(
				`h-10 w-[7.5rem] bg-orange-500 text-sm font-semibold leading-5 hover:bg-orange-700`,
				{
					'!cursor-not-allowed border !border-gray-300 !bg-gray-100 !text-gray-400': submitButtonDisabled && !isLoading
				},
				submitButtonClassName
			)}
		>
			{isLoading ? (
				<div className="flex items-center gap-2">
					<span className="inline-block size-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
					<span>Saving...</span>
				</div>
			) : (
				<>
					{!!icon && <span className={`${iconClassName}`}>{icon(submitButtonDisabled)}</span>}
					{submitButtonText}
				</>
			)}
		</Button>
	);

	return (
		<div className={`flex gap-4 ${className}`}>
			<Button
				type="button"
				onClick={onClose}
				className={`h-10 w-[7.5rem] border border-solid border-gray-300 bg-white text-sm font-semibold leading-5 !text-black hover:bg-gray-100 ${closeButtonClassName}`}
			>
				{closeButtonText}
			</Button>
			{submitButtonDisabled && submitTooltipMessage ? (
				<Tooltip placement="top">
					<Tooltip.Trigger asChild>{submitButton}</Tooltip.Trigger>
					<Tooltip.Content className="z-[100]">
						<p>{submitTooltipMessage}</p>
					</Tooltip.Content>
				</Tooltip>
			) : (
				submitButton
			)}
		</div>
	);
};
